export default __webpack_public_path__ + "static/media/blackS.6d04b48c.jpg";